export function formatDate(dateVar) {
        const parsedDate = new Date(dateVar)
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        
        const month = months[parsedDate.getMonth()]
        const day = parsedDate.getDate();
        const year = parsedDate.getFullYear();
        
        return `${month} ${day}, ${year}`;
      }